import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import AboutPage from "../views/public/AboutPage.vue";
import ContactPage from "../views/public/ContactPage.vue";
import PaymentTypesPage from "../views/public/PaymentTypesPage.vue";
import HowItWorksPage from "../views/public/HowItWorksPage.vue";
import FaqPage from "../views/public/FaqPage.vue";
import LegalPage from "../views/public/LegalPage.vue";
import LegacyHome from "../views/LegacyHome.vue";
import LegacyPage from "../views/LegacyPage.vue";
import Page404 from "../views/404.vue";

const description = "Explore Paydeck India's payments for education, rent, deposits, property, home services, contractors and suppliers. Founded in 2014.";

// Every URL listed in https://paydeck.in/sitemap.xml
const pages = [
	{ path: "/", component: Home, title: "Paydeck India | Life Doesn't Happen at a Checkout" },
	{ path: "/payment-types", component: PaymentTypesPage, title: "Payment Types | Paydeck India" },
	{ path: "/how-it-works", component: HowItWorksPage, title: "How It Works | Paydeck India" },
	{ path: "/privacy-policy", component: LegalPage, title: "Privacy Policy | Paydeck India" },
	{ path: "/terms-of-service", component: LegalPage, title: "Terms of Service | Paydeck India" },
	{ path: "/settlement-guide", component: LegalPage, title: "Fraud Reporting & Management | Paydeck India" },
	{ path: "/refund-policy", component: LegalPage, title: "Refund Policy | Paydeck India" },
	{ path: "/about-us", component: AboutPage, title: "About Us | Paydeck India", description: "The Paydeck story, from its start in India in 2014 to everyday payments for homes, education, services and suppliers." },
	{ path: "/help-center", component: ContactPage, title: "Contact Us | Paydeck India" },
	{ path: "/frequently-asked-questions", component: FaqPage, title: "FAQs | Paydeck India" }
];

const routes = [
	...pages.map(({ path, component, title, description: pageDescription }) => ({
		path,
		component,
		props: component === LegalPage ? { pageKey: path.slice(1) } : false,
		meta: { title, description: pageDescription || description }
	})),
	// The mobile app loads /page/mobile/:link in a webview without site chrome
	{ path: "/page/mobile/:link", name: "MobilePage", component: LegacyPage, props: true, meta: { legacy: true } },
	{ path: "/page/:link", redirect: (to) => `/${to.params.link}` },
	{ path: "/legacy", name: "LegacyHome", component: LegacyHome, meta: { legacy: true, title: "Paydeck (Legacy)" } },
	{ path: "/legacy/page/:link", alias: "/legacy/:link", name: "LegacyPage", component: LegacyPage, props: true, meta: { legacy: true, title: "Paydeck (Legacy)" } },
	{ path: "/:pathMatch(.*)*", name: "Page404", component: Page404, props: true, meta: { legacy: true, title: "Page not found | Paydeck India" } }
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) return savedPosition;
		if (to.hash) return { el: to.hash, top: 100, behavior: "smooth" };
		return { top: 0 };
	}
});

router.afterEach((to) => {
	document.title = to.meta.title || "Paydeck India";
	const meta = document.querySelector('meta[name="description"]');
	if (meta && to.meta.description) meta.setAttribute("content", to.meta.description);
	let canonical = document.querySelector('link[rel="canonical"]');
	if (!canonical) {
		canonical = document.createElement("link");
		canonical.setAttribute("rel", "canonical");
		document.head.appendChild(canonical);
	}
	canonical.setAttribute("href", `https://www.paydeck.in${to.path === "/" ? "" : to.path}`);
	const robots = document.querySelector('meta[name="robots"]');
	if (robots) robots.setAttribute("content", to.meta.legacy ? "noindex,nofollow" : "index,follow");
});

export default router;
